__turbopack_context__.v({
  "advancedSearchIcon": "QunIFW_advancedSearchIcon",
  "buttonContainer": "QunIFW_buttonContainer",
  "desktopMenu": "QunIFW_desktopMenu",
  "discordIcon": "QunIFW_discordIcon",
  "homepageInput": "QunIFW_homepageInput",
  "linkIcon": "QunIFW_linkIcon",
  "mainSearchInput": "QunIFW_mainSearchInput",
  "mainSearchInputContainer": "QunIFW_mainSearchInputContainer",
  "menuIcon": "QunIFW_menuIcon",
  "menuLink": "QunIFW_menuLink",
  "mobileMenu": "QunIFW_mobileMenu",
  "mobileMenuButton": "QunIFW_mobileMenuButton",
  "navInput": "QunIFW_navInput",
  "navSearchIcon": "QunIFW_navSearchIcon",
  "open": "QunIFW_open",
  "outerContainer": "QunIFW_outerContainer",
  "profileIcon": "QunIFW_profileIcon",
  "randomIcon": "QunIFW_randomIcon",
  "syntaxGuideIcon": "QunIFW_syntaxGuideIcon",
});
